import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lightbulb, X } from "lucide-react";

const HINTS = {
  "/grupos": { title: "Dica: Grupos & Líderes", text: "Use as abas Ativos/Inativos para filtrar. Toque em um card para ver endereço, líderes e a árvore de multiplicação." },
  "/frequencia": { title: "Dica: Frequência", text: "Escolha o grupo e a data, marque quem veio e registre visitantes e a oferta. O histórico fica logo abaixo." },
  "/metas": { title: "Dica: Metas & Compromissos", text: "Toque em 'Nova meta' para registrar um combinado. Alterne entre Lista e Kanban e abra o 'Diário' de cada compromisso." },
  "/atendimento": { title: "Dica: Atendimento", text: "Selecione um ou vários contatos e use os modelos de mensagem para falar pelo WhatsApp com um toque." },
  "/formacao": { title: "Dica: Estudos & Formação", text: "Marque os conteúdos como concluídos para acompanhar o seu progresso ao longo dos módulos." },
  "/calendario": { title: "Dica: Calendário", text: "Toque em um dia para criar um evento. Você pode editar e excluir eventos já criados." },
  "/contatos": { title: "Dica: Contatos", text: "Cadastre participantes e vincule cada pessoa ao grupo certo para facilitar o cuidado." },
  "/relatorios": { title: "Dica: Relatórios", text: "Gere PDFs por supervisor, líder ou grupo — prontos para imprimir e levar à reunião." },
  "/oracoes": { title: "Dica: Pedidos de Oração", text: "Envie o seu pedido e acompanhe os pedidos da comunidade para orarem juntos." },
};

export function ContextHints() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const hint = HINTS[pathname];
  const uid = user?.id || "x";
  const key = hint ? `hint_${uid}_${pathname}` : null;

  useEffect(() => {
    if (!hint || !user) { setVisible(false); return; }
    setVisible(localStorage.getItem(key) !== "1");
  }, [pathname, user, hint, key]);

  if (!hint || !visible || !user) return null;

  const dismiss = () => { if (key) localStorage.setItem(key, "1"); setVisible(false); };

  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 lg:left-auto lg:right-6 lg:translate-x-0 z-[60] w-[92%] max-w-sm" data-testid="context-hint">
      <div className="rounded-2xl border border-accent/30 bg-card shadow-xl p-4 animate-fade-up">
        <div className="flex items-start gap-3">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-accent/15 text-accent shrink-0">
            <Lightbulb className="h-5 w-5" />
          </span>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold">{hint.title}</div>
            <p className="text-sm text-muted-foreground mt-0.5">{hint.text}</p>
          </div>
          <button onClick={dismiss} data-testid="context-hint-dismiss" className="text-muted-foreground hover:text-foreground shrink-0">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-3 text-right">
          <button onClick={dismiss} className="text-xs font-semibold text-primary hover:underline">Entendi</button>
        </div>
      </div>
    </div>
  );
}
